module.exports = __webpack_public_path__ + "static/media/speaker7.1d18b400.jpg";